import { isApiMenuSource } from "@/config/menuSource";

// Connectivity check used to refuse actions that would otherwise pretend
// something reached the restaurant while the device is offline.
export function isOnline() {
  return typeof navigator === "undefined" || navigator.onLine !== false;
}

// Orders, waiter calls and bill requests: real FudiTap backend calls with the
// real (API) menu, local mocks only in development/test (mock) mode. A failed
// real call is always reported, never replaced by a mock.
export function restaurantActionsAvailable() {
  return true;
}

export const usesRealBackend = () => isApiMenuSource();
